import { toRefs, reactive, computed, onMounted } from 'vue';

// const layoutConfig = reactive({
//   ripple: true,
//   darkTheme: false,
//   inputStyle: 'outlined',
//   menuMode: 'static',
//   theme: 'aura-light-green',
//   scale: 14,
//   primary: 'green',
//   surface: '',
//   preset: 'Aura',
//   activeMenuItem: null,
// });

// localStorage에서 설정을 불러오는 함수
export const loadLayoutConfig = () => {
  const savedConfig = localStorage.getItem('layoutConfig');
  if (savedConfig) {
    return { ...JSON.parse(savedConfig) };
  }
  return {
    ripple: true,
    darkTheme: false,
    inputStyle: 'outlined',
    menuMode: 'static',
    theme: 'aura-light-green',
    scale: 14,
    primary: 'orange',
    surface: 'viva',
    preset: 'CLara',
    activeMenuItem: null,
  };
};

// localStorage에서 상태를 불러오는 함수
export const loadLayoutState = () => {
  const savedState = localStorage.getItem('layoutState');
  if (savedState) {
    return { ...JSON.parse(savedState) };
  }
  return {
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    isHorizontalMenu: false,
  };
};

// const layoutState = reactive({
//   staticMenuDesktopInactive: false,
//   overlayMenuActive: false,
//   profileSidebarVisible: false,
//   configSidebarVisible: false,
//   staticMenuMobileActive: false,
//   menuHoverActive: false,
//   isHorizontalMenu: false, // 기본값은 수직 메뉴
// });

const layoutConfig = reactive(loadLayoutConfig());
const layoutState = reactive(loadLayoutState());

// 설정 저장 함수
const saveLayoutConfig = () => {
  localStorage.setItem('layoutConfig', JSON.stringify(layoutConfig));
};

// 상태 저장 함수
const saveLayoutState = () => {
  localStorage.setItem('layoutState', JSON.stringify(layoutState));
};

export function useLayout() {
  // 초기 설정 적용
  onMounted(() => {
    if (layoutConfig.darkTheme) {
      document.documentElement.classList.add('app-dark');
    }
  });

  const setScale = (scale) => {
    layoutConfig.scale = scale;
    saveLayoutConfig();
  };

  const setActiveMenuItem = (item) => {
    layoutConfig.activeMenuItem = item;
    saveLayoutConfig();
  };

  const onMenuToggle = () => {
    if (layoutConfig.menuMode === 'overlay') {
      layoutState.overlayMenuActive = !layoutState.overlayMenuActive;
    }

    if (window.innerWidth > 991) {
      layoutState.staticMenuDesktopInactive =
        !layoutState.staticMenuDesktopInactive;
    } else {
      layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive;
    }
  };

  const isSidebarActive = computed(
    () => layoutState.overlayMenuActive || layoutState.staticMenuMobileActive,
  );

  const isDarkTheme = computed(() => layoutConfig.darkTheme);

  const toggleDarkMode = () => {
    layoutConfig.darkTheme = !layoutConfig.darkTheme;
    document.documentElement.classList.toggle('app-dark');
    saveLayoutConfig();
  };

  const setPrimary = (value) => {
    layoutConfig.primary = value;
    saveLayoutConfig();
  };

  const setSurface = (value) => {
    layoutConfig.surface = value;
    saveLayoutConfig();
  };

  const setPreset = (value) => {
    layoutConfig.preset = value;
    saveLayoutConfig();
  };

  const setMenuMode = (mode) => {
    layoutConfig.menuMode = mode;
    saveLayoutConfig();
  };

  // 메뉴 위치를 토글하는 함수
  const toggleMenuPosition = () => {
    layoutState.isHorizontalMenu = !layoutState.isHorizontalMenu;
    // 메뉴 위치 변경 시 사이드바 상태를 초기화
    layoutState.staticMenuDesktopInactive = false;
    layoutState.overlayMenuActive = false;
    layoutState.staticMenuMobileActive = false;
    saveLayoutState();
  };

  return {
    layoutConfig: toRefs(layoutConfig),
    layoutState: toRefs(layoutState),
    setScale,
    onMenuToggle,
    isSidebarActive,
    isDarkTheme,
    setActiveMenuItem,
    toggleDarkMode,
    setPrimary,
    setSurface,
    setPreset,
    setMenuMode, // 추가
    toggleMenuPosition,
  };
}
